import { formatDate } from "@angular/common";
import { Component, Inject, Input, OnInit } from "@angular/core";
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from "@angular/forms";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { MatSnackBar } from "@angular/material/snack-bar";
import { Router } from "@angular/router";
import { AdminService } from "../admin.service";

@Component({
  selector: "app-admin-add-notes",
  templateUrl: "./admin-add-notes.component.html",
  styleUrls: ["./admin-add-notes.component.css"],
})
export class AdminAddNotesComponent implements OnInit {
  addNotesForm!: FormGroup;
  date = new FormControl(new Date());
  serializedDate = new FormControl(new Date().toISOString());
  today: any;
  @Input() min: any;
  minDate = new Date();
  token: any;
  loading: boolean = false;

  constructor(
    private matdialogref: MatDialogRef<AdminAddNotesComponent>,
    private formBuilder: FormBuilder,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private services: AdminService,
    private router: Router,
    private snackBar: MatSnackBar
  ) {}

  ngOnInit(): void {
    this.token = localStorage.getItem("adminToken");
    this.addNotesForm = this.formBuilder.group({
      date: ["", [Validators.required]],
      employee_name: [
        "",
        Validators.compose([
          Validators.required,
          Validators.pattern("^[a-zA-Z][a-zA-Z\\s]+$"),
        ]),
      ],
      notes: ["", [Validators.required]],
    });
  }

  close() {
    this.matdialogref.close();
  }

  public formatFormDate(date: Date) {
    return formatDate(date, "yyyy-MM-dd hh:mm", "en");
  }

  saveLog(event: any) {
    // if (this.addNotesForm.valid) {
    if (!this.addNotesForm.valid || this.loading) {
      return; // 🚀 Prevent clicks if already loading
    }
    this.loading = true; // ✅ Disable button immediately
    (event.target as HTMLButtonElement).disabled = true; // ✅ Disable button instantly
    const notesObj = {
      module_type: this.data.module_type,
      module_type_id: this.data._id,
      date: this.formatFormDate(this.addNotesForm.value.date),
      employee_name: this.addNotesForm.value.employee_name,
      notes: this.addNotesForm.value.notes,
      module_id: "admin",
    };

    this.services.addNotes(notesObj, this.token).subscribe(
      (response: any) => {
        if (response.status == 201 || response.status == 200) {
          this.matdialogref.close();
        }
        setTimeout(() => {
          this.loading = false; // ✅ Enable button after response
          (event.target as HTMLButtonElement).disabled = false; // ✅ Re-enable button
        }, 500);
      },
      (error) => {
        if (error.error.message === "jwt malformed") {
          this.router.navigateByUrl("admin/login");
          window.localStorage.clear();
        }
        if (error.error.message === "jwt expired") {
          this.router.navigateByUrl("admin/login");
          window.localStorage.clear();
        }
        this.snackBar.open(error.error.message, "Fail", {
          duration: 5000,
        });
      }
    );
    // } else {
    //   this.addNotesForm.markAllAsTouched();
    // }
  }
}
